import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ManageRoles = Loadable(lazy(() => import("./CoreRolesList")));
const ManageRolesEdit = Loadable(lazy(() => import("./CoreRolesAdd")));

const CoreRolesRoutes = [
  { path: "/roles/manage-roles", element: <ManageRoles /> },
  { path: "/roles/manage-roles/:mode/:id", element: <ManageRolesEdit /> },
];

export default CoreRolesRoutes;
